import { configureStore } from '@reduxjs/toolkit';
import appSlice from './slices/appSlices';

export const store = configureStore({
    reducer: {
        app: appSlice,
    },
});
